import React from 'react';
import { Loader2 } from 'lucide-react';

interface PaymentModalProps {
    plan: string;
    cycle: string;
    price: number;
    onClose: () => void;
    onConfirm: () => void;
    isProcessing: boolean;
}

export const PaymentModal: React.FC<PaymentModalProps> = ({ plan, cycle, price, onClose, onConfirm, isProcessing }) => (
    <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4 backdrop-blur-sm animate-fadeIn">
        <div className="bg-white rounded-2xl w-full max-w-md overflow-hidden shadow-2xl">
            <div className="bg-slate-50 p-6 border-b border-slate-100 flex justify-between items-center">
                <div>
                    <h3 className="text-lg font-bold text-slate-900">Subscribe to {plan}</h3>
                    <p className="text-sm text-slate-500">{cycle} billing</p>
                </div>
                <div className="text-right">
                    <span className="block text-2xl font-bold text-slate-900">${price}</span>
                    <span className="text-xs text-slate-400">due today</span>
                </div>
            </div>
            <div className="p-6 space-y-4">
                <div className="space-y-2">
                    <label className="text-xs font-bold text-slate-500 uppercase">Card Information</label>
                    <div className="border border-slate-300 rounded-lg overflow-hidden flex flex-col">
                        <input type="text" placeholder="Card number" className="p-3 outline-none border-b border-slate-200 text-slate-900" />
                        <div className="flex">
                            <input type="text" placeholder="MM / YY" className="w-1/2 p-3 outline-none border-r border-slate-200 text-slate-900" />
                            <input type="text" placeholder="CVC" className="w-1/2 p-3 outline-none text-slate-900" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="p-4 bg-slate-50 flex justify-end gap-3">
                <button onClick={onClose} disabled={isProcessing} className="px-4 py-2 text-slate-600 font-medium hover:bg-slate-200 rounded-lg transition">Cancel</button>
                <button onClick={onConfirm} disabled={isProcessing} className="px-6 py-2 bg-black text-white font-bold rounded-lg hover:opacity-80 flex items-center gap-2 transition">
                    {isProcessing && <Loader2 className="animate-spin" size={16} />}
                    {isProcessing ? 'Processing...' : `Pay $${price}`}
                </button>
            </div>
        </div>
    </div>
);
